module.exports = __webpack_public_path__ + "media/images/icons/image-ca9317d557cbf649a1e9e7e9784d7bea.svg";